<template>
  <b-alert class="validation-error-alert"
           variant="danger"
           :show="formErrorList.length > 0">
    <div v-for="error in formErrorList">
      {{ error }}
    </div>
  </b-alert>
</template>

<script>
export default {
  name: 'ValidationErrorAlert',
  props: {
    formErrorList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/form/validation/ValidationErrorAlert.vue